import { StudentsTableWrapper } from "@app/modules/educator/educator-component";
import { AuthContext } from "@app/providers";
import { getClassroom, getGoogleClassrooms, googleClassroomSync } from "@app/services";
import { useLocation } from "@app/utils";
import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import { DefaultMessage, EmptyContainer } from "../commonStyles";
import Layout from "../mainLayout/layout";
import { Icon, Button, Toast } from "@app/components";
import Checkbox from "../checkbox";
import { ButtonContainer } from "../header/header.component";

export default function GoogleStudents() {
    const { userInfo }: any = useContext(AuthContext);
    const userToken = userInfo && userInfo.sessionToken;
    const [spinner, setSpinner] = useState(false);
    const { navigate } = useLocation();
    const { handleSubmit }: any = useForm();
    const [classRoomDetails, showClassRoomDetails] = useState<any>([]);
    const [studentsList, setStudentsList] = useState<any>([]);
    const [returnData, setReturnData] = useState<boolean>(false)
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState<any>({
        type: "",
        message: "",
    });
    const studentIds: any = [];
    const [syncedIds, setSyncedIds] = useState<any>([]);
    const [isClassroomSync, setIsClassroomSync] = useState<boolean>(false);
    const [kazooClassRoomId, setKazooClassroomId] = useState<string>('');
    const [isSelectAll, setSelectAll] = useState<boolean>(false);
    const [isChecked,setIsChecked] = useState(true)

    let routeParams = useParams();
    let history = useHistory();

    useEffect(() => {
        googleClassrooms();
    }, []);

    function googleClassrooms() {
        const params: any = {};
        setSpinner(true);
        let classroomId = Object.values(routeParams)[0]

        // const classroomId = routeParams.get('params');
        Object.assign(params, {
            userId: userInfo && userInfo.userJson.userId,
            sessionToken: userToken,
            classroomId: classroomId
        });
        getGoogleClassrooms(params)
            .then((res) => {
                if (res._responseStatus == 1) {
                    setReturnData(true)
                    showClassRoomDetails(res.allClassroomDocs);
                    let classroomData = res.allClassroomDocs.studentData;
                    classroomData.map(function (value: any) {
                        value['selected'] = false;
                        if (value.isUserSync) {
                            syncedIds.push(value.googleAccountId)
                            value['selected'] = true;
                        }
                    });
                    setStudentsList(classroomData); 
                    setSpinner(false);
                    setIsClassroomSync(res.allClassroomDocs.isClassroomSync);
                    setKazooClassroomId(res.allClassroomDocs.kazooClassRoomId);
                    setSyncedIds(syncedIds);
                }
                else {
                    setSpinner(false);
                    setReturnData(false);
                }
            })
    }

    function onSubmit() {
        const params: any = {};
        setSpinner(true);
        let googleClassroomId = Object.values(routeParams)[0];
        studentsList.map(function (value: any) {
            if (value.selected)
            studentIds.push(value.googleAccountId)
        });
        Object.assign(params, {
            userId: userInfo && userInfo.userJson.userId,
            sessionToken: userToken,
            googleClassroomId: googleClassroomId,
            studentIds: JSON.stringify(studentIds),
            syncedIds: JSON.stringify(syncedIds),
            kazooClassroomId: kazooClassRoomId,
            isGoogleClassroom: isClassroomSync,
            kazooStudentIds: JSON.stringify(classRoomDetails.kazooStudentIds)
        });
        googleClassroomSync(params)
            .then((res) => {
                if (res._responseStatus == 1) {
                    setSpinner(false);
                    setToastMessage({
                        type: 'success',
                        message: res.message
                    });
                    setShowToast(true);
                    getClassroomDetails();
                    navigate('/classrooms')
                }
                else {
                    setSpinner(false);
                    setReturnData(false);
                    setToastMessage({
                        type: 'error',
                        message: res.msg
                    });
                    setShowToast(true);
                }
            })
    }

    function getClassroomDetails()  {
        const params: any = {};
        Object.assign(params, {
            sessionToken: userInfo && userInfo.sessionToken,
            userId: userInfo && userInfo.userJson.userId,
        });
        setSpinner(true)

        getClassroom(params)
            .then((resp: any) => {
                const response = resp;
                if (response._responseStatus === 1) {
                    localStorage.setItem("classRooms", JSON.stringify(response.allClassroomsDocs))
                }
                else {
                    setSpinner(false)
                }
            })

    }

    function handleChange(evt: any, id: number) {
        let list =[...studentsList];
        setStudentsList([]);
        list[id]['selected'] = !list[id]['selected'] ;
        setIsChecked(false)
        setStudentsList(list)
        setIsChecked(true)
        if(evt.target.value == false){
            setSelectAll(false)
        }
        // list.forEach(item => {
        //     setSelectAll(true)
        //     if(!item.selected){
        //         setSelectAll(false)
        //     }
        // });
    }
    function selectAll(evt:any){
        let list = studentsList
        list.forEach((value:any) => {
            value.selected = evt.target.checked;
        });
        setStudentsList(list)
        setSelectAll(evt.target.checked);
    }

    return (
        <Layout classRoomLayout={false}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <h2 className="primary-header text-center mb-1">{classRoomDetails.classRoomName}</h2>
                {returnData && studentsList && <h4 className="secondary-header mb-3">Students ({studentsList.length} of {classRoomDetails.noOfStudents})</h4>}
                <StudentsTableWrapper>
                    <table>
                        <thead>
                            <tr>
                                <th className="w-40 pb-30">
                                    <Checkbox name="selectStudents" checked={isSelectAll} onChange={(evt) => selectAll(evt)}></Checkbox>
                                </th>
                                <th className="w-160">First Name</th>
                                <th className="w-160">Last Name</th>
                                <th className="w-250">Email Address</th>
                            </tr>
                        </thead>
                        <tbody>
                            {studentsList && !spinner && studentsList.map((student: any, index: any) => {
                                if (student) {
                                    return (
                                        <tr key={index}>
                                            <td className="w-40 pb-30">
                                                { <Checkbox  name="selectStudents" checked={student.selected} 
                                                onChange={(evt) => handleChange(evt, index)}></Checkbox>
                                                }
                                            </td>
                                            <td className="w-160">{student.firstName}</td>
                                            <td className="w-160">{student.lastName}</td>
                                            <td className="w-250">{student.email}</td>
                                        </tr>
                                    )
                                }
                            })}
                           

                        </tbody>
                    </table>
                    {/* {maxStudentErr && <p>Max no.of students exceded</p>} */}
                </StudentsTableWrapper>
                {spinner &&
                <EmptyContainer>
                    <Icon name="loader" />
                    <DefaultMessage>Loading, please wait...</DefaultMessage>
                </EmptyContainer>
                }
                {returnData && studentsList.length === 0 && spinner === false &&
                  <EmptyContainer>
                    <DefaultMessage className="mb-2">No Students found for the Google Classroom</DefaultMessage>
                  </EmptyContainer>
                }
                <ButtonContainer>
                    <Button
                        type="submit"
                        variant="newsecondary"
                        size="large"
                        width="100%"
                        disabled={studentsList.length === 0}
                    // onClick={() => setShowSuccessPopUp(true)}
                    >
                        Sync with Google
                    </Button>
                </ButtonContainer>
                <Button type="button" variant="bordered" size="large" width={"100%"} style={{marginTop:"10px"}} onClick={() => history.replace("/google-classrooms")}>Cancel</Button>
            </form>
            <Toast
                message={toastMessage.message}
                showToast={showToast}
                type={toastMessage.type}
                onClose={() => setShowToast(false)}
            />
        </Layout>
    );
}